
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bonuses/[module]/[lesson]",
      function () {
        return require("private-next-pages/bonuses/[module]/[lesson]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bonuses/[module]/[lesson]"])
      });
    }
  